// Forms. A form marked data-n-busy-form disables its submit button while it submits and swaps
// the label for the button's data-busy-label ("Signing in…"), so a slow request can't be sent
// twice. Runs after the confirm dialog, so a cancelled confirmation leaves the button alone.
export function initForms(): void {
	document.addEventListener('submit', (e) => {
		const form = e.target as HTMLFormElement;
		if (!form.hasAttribute('data-n-busy-form')) return;
		setTimeout(() => {
			if (e.defaultPrevented || !form.checkValidity()) return;
			const button =
				((e as SubmitEvent).submitter as HTMLButtonElement | null) ??
				form.querySelector<HTMLButtonElement>('button[type=submit]');
			if (!button) return;
			if (button.dataset.busyLabel) button.textContent = button.dataset.busyLabel;
			button.disabled = true;
			button.setAttribute('aria-busy', 'true');
		}, 0);
	});
	// Coming back with the browser's back button shows the page from cache: re-enable.
	window.addEventListener('pageshow', () => {
		for (const button of document.querySelectorAll<HTMLButtonElement>('button[aria-busy="true"]')) {
			button.disabled = false;
			button.removeAttribute('aria-busy');
		}
	});
}
